import React from 'react';
import  "../style/setSolicitorPassword.css";
import Dots from 'react-activity/lib/Dots';
import '../style/dots.css';
import Button from "./button";
import aragLogo from '../araglogo3@2x.png';

const SetUserPassword = (props) => {
    return (
        <div>
            <div className="container ">
                <div className="row ">
                    <div className="col-lg-4 ">
                    </div>
                    <div className="col-lg-4 middle-col-lg-4 ">
                        <div className="wrapperStyle">
                            <img className="logoStyle" src={aragLogo} alt=""/>
                            <form className="formStyle" onSubmit={props.handleSubmit}>
                                <div className="form-group form-group-width">
                                    <label className="formTitleStyle">Set Password</label>
                                </div>
                                <div className="form-group">
                                    <label className="control-label.text-left formGroup-textInput-label">
                                        {'Password'}
                                        <span>{' '}*</span>
                                    </label>
                                    <input type='password'
                                           required={true}
                                           className="form-control formGroup-textInput-input"
                                           name="password"
                                           value={props.store.password}
                                           onChange={(evt) => props.changeUserSetPasswordSettings(evt.target.name, evt.target.value)}/>
                                </div>
                                <div className="form-group">
                                    <label className="control-label.text-left formGroup-textInput-label">
                                        {'Retype Password'}
                                        <span>{' '}*</span>
                                    </label>
                                    <input type='password'
                                           required={true}
                                           className="form-control formGroup-textInput-input"
                                           name="retypedPassword"
                                           value={props.store.retypedPassword}
                                           onChange={(evt) => props.changeUserSetPasswordSettings(evt.target.name, evt.target.value)}/>
                                </div>
                                <div className="form-group">
                                    <Button
                                        customArrowStyle="setSolicitorPassword-login-arrow"
                                        btnType="submit"
                                        btnStyle={'btn btn-primary btn-xs sharp yellow btn-full-width'}
                                        label="Submit"/>
                                    <div className="col-sm-3">
                                    </div>
                                    <div className="col-sm-3"></div>
                                </div>
                                {props.isPasswordInvalid && (
                                    <div className="setSolicitorPassword-successAuthDialogBoxInfo">
                                        <span >Password must contain at least:</span>
                                        <ul>
                                            {!props.store.password.match(/[a-z]/) && (
                                                <li>
                                                    {'one lower case character'}
                                                </li>
                                            )
                                            }
                                            {!props.store.password.match(/[A-Z]/) && (
                                                <li>
                                                    {'one upper case character'}
                                                </li>
                                            )
                                            }
                                            {!props.store.password.match(/\d/) && (
                                                <li>
                                                    {'one digit character'}
                                                </li>
                                            )
                                            }
                                            {!props.store.password.match(/\W/) && (
                                                <li>
                                                    {'one special character'}
                                                </li>
                                            )
                                            }
                                            {props.store.password.length < 8 && (
                                                <li>
                                                    {'8 characters'}
                                                </li>
                                            )
                                            }
                                        </ul>
                                    </div>
                                )}
                                {props.store.badMsg !== '' ?
                                    <div className="setSolicitorPassword-rejectAuthDialogBoxInfo">
                                        <div className="">{props.store.badMsg }
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                            </form>
                            {props.store.posting?
                                <div className="col-sm-12">
                                    <div className="col-sm-4"></div>
                                    <div className="col-sm-4">
                                        <Dots /></div>
                                    <div className="col-sm-4"></div>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <div className="col-lg-4 "></div>
                </div>
            </div>
        </div>
    )
};

export default SetUserPassword;